import GridItem from '../../../components/Grid/GridItem';
import React from 'react';

interface IErrorText {
	message: string;
}

const ErrorText = ({ message }: IErrorText) => {
	return (
		<GridItem xs={12} sm={12} md={12} lg={12}>
			<h3 style={{ textAlign: 'center', marginBottom: '30px', color: '#3c4858' }}>{message}</h3>
		</GridItem>
	);
};

export default ErrorText;
